export default __webpack_public_path__ + "static/media/Electronics.dee1510a.webp";